package services

import io.ktor.client.*
import io.ktor.client.plugins.contentnegotiation.*
import io.ktor.serialization.kotlinx.json.*
import it.neckar.lizergy.model.serializers.wunschsolarModel
import kotlinx.serialization.json.Json
import kotlinx.serialization.modules.SerializersModule
import services.http.WunschsolarClientService

/**
 * Contains the services that are used in the UI
 */

/**
 * Shared [Json] for Wunschsolar.
 *
 * Used both for ContentNegotiation and for explicit-serializer decoding via
 * `HttpResponse.wunschsolarBody`. See #2098: Ktor's reflective `.body()` resolution mis-resolves
 * sealed types on Kotlin/JS in the full app bundle (the class discriminator `type` becomes an
 * unknown key); passing the generated `<Type>.serializer()` explicitly bypasses that.
 */
val wunschsolarJson: Json = Json {
  serializersModule = SerializersModule {
    wunschsolarModel()
  }
}

/**
 * HTTP client without authorization.
 */
val httpClientNoAuth: HttpClient = HttpClient {
  install(ContentNegotiation) {
    json(wunschsolarJson)
  }
}

/**
 * Storage service
 */
val wunschsolarService: WunschsolarClientService = WunschsolarClientService(httpClientNoAuth)
